<script>
    import PageTransition from "../components/PageTransition.svelte";
    import PriceCard from "../components/PriceCard.svelte";

    import { onMount } from "svelte";

    onMount(() => {
        window.scrollTo(0, 0);
    });

    function scrollToFeatures() {
        window.scrollTo(
            document.getElementById("features").getBoundingClientRect().x,
            document.getElementById("features").getBoundingClientRect().y
        );
    }

    function switchVideo() {
        if (document.getElementById("video").src.includes("minecraft.mp4")) {
            document.getElementById("video").src = "nether.mp4";
        } else {
            document.getElementById("video").src = "minecraft.mp4";
        }
    }
</script>

<head>
    <link rel="canonical" href="https://fyrehost.net/minecraft" />
    <link rel='stylesheet' href='global.css'>
	<link rel='stylesheet' href='build/bundle.css'>
    <meta name="description" content="Cheap and Fast Minecraft Server Hosting with Unlimited Slots and Lifetime Pricing!">
    <style>
        html {
            scroll-behavior: smooth;
        }
        
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #3B375E;
            /*border-radius: 10px;*/
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #68638D;
            border-radius: 10px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #9992BF;
        }
    
    </style>
</head>
<div />
<PageTransition>
    <div class="md:h-screen mx-10 grid place-items-center">
        <div class="h-1/5 text-center text-9xl text-white font-bold">
            <div class="mt-8">Minecraft Hosting</div>
        </div>
        <hr />
        <div class="flex flex-wrap h-4/5">
            <div class="md:w-7/12 w-full h-full">
                <div class="h-full w-full">
                    <video
                        id="video"
                        autoplay={true}
                        class="rounded-lg ring-2 ring-blue-800  aspect-video"
                        src="minecraft.mp4"
                        on:ended={switchVideo}
                    >
                        <track kind="captions" />
                    </video>
                </div>
            </div>
            <div class="md:w-5/12 w-full h-full">
                <div class="flex flex-wrap h-full">
                    <div class="w-5/6 mx-auto my-auto">
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Unlimited Slots
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Host as many users as you want on your Minecraft
                                server with no slot or bandwith limits!
                            </dd>
                        </div>
                    </div>

                    <div class="w-5/6 mx-auto my-auto">
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-green-400 to-green-600 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Version Control
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Install any version of Minecraft with a simple
                                click. Support Versions include Vanilla, Spigot,
                                PaperSpigot, and Fabric!
                            </dd>
                        </div>
                    </div>

                    <div class="w-5/6 mx-auto my-auto">
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Lifetime Pricing
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                The price you buy at, is the price you keep! We
                                will never raise your price from when you
                                purchased.
                            </dd>
                        </div>
                    </div>

                    <div class="w-5/6 mx-auto my-auto">
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-gray-400 to-gray-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    FyrePanel
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Control all aspects of your server with our powerful custom FyrePanel!
                            </dd>
                        </div>
                    </div>
                    <div class="w-5/6 mx-auto mt-auto bottom-0">
                        <button
                            on:click={scrollToFeatures}
                            style="background-color: #1C1C3E;"
                            class="rounded-full my-auto h-20 w-full ring-2 ring-blue-800"
                        >
                            <div
                                class="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-red-500 to-pink-500 text-4xl font-bold"
                            >
                                View More Features
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        id="features"
        style="display:flex;align-items:center;justify-content:center;"
        class="h-screen"
    >
        <div class="my-auto">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="lg:text-center">
                    <h2
                        class="text-transparent bg-clip-text font-bold bg-white text-8xl tracking-wide uppercase"
                    >
                        FEATURES
                    </h2>
                    <p class="mt-4 max-w-2xl text-xl text-gray-400 lg:mx-auto">
                        Get better hosting at a lower cost.
                    </p>
                </div>

                <div class="mt-10">
                    <dl
                        class="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10"
                    >
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        class="h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Free Subdomain
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Use the included subdomain to connect to your
                                server without needing an ip or a port
                                specified.
                            </dd>
                        </div>

                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-green-400 to-green-600 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        class="h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    The best value
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Unlike other hosts, we have built our
                                infrastructure from the ground up to offer the
                                lowest cost hosting solutions while still
                                offering the best experience to our customers!
                            </dd>
                        </div>

                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-gray-400 to-gray-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Hardware
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Our server hardware was selected to offer the
                                best game server experience, unlike other hosts
                                which use the same servers for everything.
                            </dd>
                        </div>

                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Control your server better
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                We have engineered our solution to add features
                                like version control and backups, along with the
                                addition of PhpMyAdmin to enhance the control
                                you have over your server!
                            </dd>
                        </div>
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Files
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Manage your server execution better with our
                                file management and version control solutions.
                            </dd>
                        </div>

                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-gray-400 to-gray-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Support
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Our support team is readily accessible through
                                discord for the fastest experience possible,
                                don't wait for email support to respond any
                                longer!
                            </dd>
                        </div>
                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-red-400 to-red-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    SLA
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                We offer a 99.9% uptime SLA, if your server goes
                                down, we will reimburse you!
                            </dd>
                        </div>

                        <div class="relative">
                            <dt>
                                <div
                                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-red-500 hover:to-yellow-500 text-white"
                                >
                                    <svg
                                        class="h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M13 10V3L4 14h7v7l9-11h-7z"
                                        />
                                    </svg>
                                </div>
                                <p
                                    class="ml-16 text-lg leading-6 font-medium text-white"
                                >
                                    Fast Provisioning
                                </p>
                            </dt>
                            <dd class="mt-2 ml-16 text-base text-gray-400">
                                Start playing in less than 5 minutes after
                                purchasing, no need to wait for your server to
                                get ready!
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </div>

    <PriceCard
        name="Minecraft"
        price="2"
        cpu="2 vCores"
        ram="2GB DDR4 RAM"
        paymentLink="https://buy.stripe.com/14k7uh4WdaZF0nK003"
        paymentLinkDE="https://buy.stripe.com/28o3e12O5gjZeeA7sP"
        paymentLinkUSE="https://buy.stripe.com/3cs4i5bkB1p56M89Bk"
        paypalLink="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-6DC358357B935993LMFKUZ3A"
        paypalLinkDE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-173939028T9796945MGNLTTA"
        paypalLinkUSE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-03L64322NR606890NMG7JXZA"
        name2="Minecraft"
        price2="4"
        cpu2="2 vCores"
        ram2="4 GB DDR4 RAM"
        paypalLink2="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-2JL64892X9177905LMFKU3GY"
        paypalLink2DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-01R19789F84480441MGNMJHA"
        paypalLink2USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-56866579HE8274635MG7JXOA"
        paymentLink2="https://buy.stripe.com/7sIaGt0FX8Rx0nKeUZ"
        paymentLink2DE="https://buy.stripe.com/4gweWJdsJgjZ9YkcNa"
        paymentLink2USE="https://buy.stripe.com/6oE29XgEV2t98UgfZH"
        name3="Minecraft"
        price3="6"
        cpu3="2 vCores"
        ram3="6GB DDR4 RAM"
        paypalLink3="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8AP731085N507715SMFKU4NY"
        paypalLink3DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8S45287805294333TMGNN6II"
        paypalLink3USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8AA616073T620405RMG7JW2Y"
        paymentLink3="https://buy.stripe.com/5kA01PfAR5Fl7QceV1"
        paymentLink3DE="https://buy.stripe.com/5kA4i5ewN1p5eeAfZn"
        paymentLink3USE="https://buy.stripe.com/28o29XfAR2t9fiEaFm"
        name4="Minecraft"
        price4="8"
        cpu4="2 vCores"
        ram4="8GB DDR4 RAM"
        paypalLink4="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-05L47025L63028913MFKVHKY"
        paypalLink4DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4AT52824U8447161PMGNOFIQ"
        paypalLink4USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7WD55950MC388845KMG7JWSY"
        paymentLink4="https://buy.stripe.com/28ocOBbkBgjZ2vS8wF"
        paymentLink4DE="https://buy.stripe.com/14k15T3S9gjZ6M8bJ8"
        paymentLink4USE="https://buy.stripe.com/6oE4i52O5c3J0nKdRx"
    />
</PageTransition>
